import React from "react";
import { QuestionCard } from "../shared/QuestionCard";
import { QuizChoiceCard, ChoiceOption } from "../form/QuizChoiceCard";
import { Fussiness, FUSSINESS_LABEL } from "@/helpers/enums";
import { quizAsset } from "../shared/quizAssets";

type Props = {
  dogName: string;
  value?: string | null;
  onChange: (value: Fussiness) => void;
};

const OPTIONS: ChoiceOption[] = [
  {
    value: Fussiness.FOODIE,
    label: FUSSINESS_LABEL[Fussiness.FOODIE],
    sublabel: "Loves just about anything",
    icon: quizAsset("icon-fussy-foodie"),
  },
  {
    value: Fussiness.GOOD_EATER,
    label: FUSSINESS_LABEL[Fussiness.GOOD_EATER],
    sublabel: "Cleans the bowl most days",
    icon: quizAsset("icon-fussy-good"),
  },
  {
    value: Fussiness.CAN_BE_FUSSY,
    label: FUSSINESS_LABEL[Fussiness.CAN_BE_FUSSY],
    sublabel: "Leaves food sometimes",
    icon: quizAsset("icon-fussy-can"),
  },
  {
    value: Fussiness.VERY_FUSSY,
    label: FUSSINESS_LABEL[Fussiness.VERY_FUSSY],
    sublabel: "Regularly refuses",
    icon: quizAsset("icon-fussy-very"),
  },
];

/** Issue #52 A3 — fussiness gets its own treatment: it's ~19% of named
 *  barriers and a near-disjoint population from the price objectors. */
export function FussinessQuestion({ dogName, value, onChange }: Props) {
  return (
    <QuestionCard title={`How is ${dogName || "your dog"} at mealtimes?`}>
      <QuizChoiceCard
        options={OPTIONS}
        selected={value ?? ""}
        onSelect={(v) => onChange(v as Fussiness)}
        size="sm"
      />
    </QuestionCard>
  );
}
